(function() {
  'use strict';

  // Funzione helper per ottenere il valore di un cookie
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
    return null;
  }

  // Funzione per scadere un cookie
  function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  const discountCode = getCookie('discount_code');
  if (discountCode) {
    console.log('Deceit Discount Code Rilevato:', discountCode);
    initDiscountToast(discountCode);
    initCartDiscountSync(discountCode);
  }

  function initDiscountToast(code) {
    const injectToast = () => {
      // Inietta stili CSS del Toast nel document header
      const style = document.createElement('style');
      style.textContent = `
        .deceit-discount-toast {
          position: fixed;
          bottom: 24px;
          left: 50%;
          transform: translate(-50%, 150%);
          background-color: #FCF40F;
          color: #0A0A0A;
          border: 2px solid #0A0A0A;
          border-radius: 0px;
          padding: 1rem 2.5rem 1rem 1.5rem;
          z-index: 9999;
          font-family: 'ABCFavorit', Helvetica, Arial, sans-serif;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          display: flex;
          align-items: center;
          gap: 1.5rem;
          box-shadow: 6px 6px 0px rgba(10, 10, 10, 1);
          opacity: 0;
          transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.4s ease;
          width: max-content;
          max-width: calc(100% - 32px);
        }
        .deceit-discount-toast.active {
          transform: translate(-50%, 0);
          opacity: 1;
        }
        .deceit-discount-toast.active.no-transition {
          transform: translate(-50%, 0) !important;
        }
        .deceit-discount-toast.no-transition {
          transition: none !important;
        }
        .deceit-discount-toast__close {
          position: absolute;
          top: 4px;
          right: 8px;
          background: none;
          border: none;
          color: #0A0A0A;
          font-weight: 700;
          font-size: 1.4rem;
          cursor: pointer;
          padding: 0 0.25rem;
          transition: color 0.15s ease;
          line-height: 1;
        }
        .deceit-discount-toast__close:hover {
          color: #0000FF;
        }
        @media (max-width: 767px) {
          .deceit-discount-toast {
            left: 16px;
            bottom: 16px;
            width: 66.666%;
            max-width: calc(100% - 32px);
            transform: translate(0, 150%);
            padding: 0.875rem 2.25rem 0.875rem 1.25rem;
          }
          .deceit-discount-toast.active {
            transform: translate(0, 0);
          }
          .deceit-discount-toast.active.no-transition {
            transform: translate(0, 0) !important;
          }
        }
      `;
      document.head.appendChild(style);

      // Controlla se il toast è già stato mostrato in questa sessione (navigazione successiva)
      const hasBeenShown = sessionStorage.getItem('deceit_discount_toast_shown') === 'true';

      // Crea elemento HTML del Toast con prevenzione DOM XSS
      const toast = document.createElement('div');
      if (hasBeenShown) {
        toast.className = 'deceit-discount-toast active no-transition';
      } else {
        toast.className = 'deceit-discount-toast';
      }
      
      const toastText = document.createElement('span');
      toastText.innerHTML = 'CODICE SCONTO <span style="text-decoration: underline;" class="deceit-code-placeholder"></span> APPLICATO!';
      toastText.querySelector('.deceit-code-placeholder').textContent = code;
      
      const closeBtn = document.createElement('button');
      closeBtn.className = 'deceit-discount-toast__close';
      closeBtn.setAttribute('aria-label', 'Chiudi');
      closeBtn.innerHTML = '&times;';
      
      toast.appendChild(toastText);
      toast.appendChild(closeBtn);

      document.body.appendChild(toast);

      if (!hasBeenShown) {
        // Trigger per animazione d'ingresso solo al primo atterraggio
        setTimeout(() => {
          toast.classList.add('active');
          sessionStorage.setItem('deceit_discount_toast_shown', 'true');
        }, 500);
      } else {
        // Rimuove no-transition subito dopo in modo che l'animazione di chiusura funzioni
        setTimeout(() => {
          toast.classList.remove('no-transition');
        }, 50);
      }

      // Gestione chiusura
      closeBtn.addEventListener('click', () => {
        toast.classList.remove('active');
        setTimeout(() => {
          toast.remove();
        }, 400);
      });
    };

    if (document.body) {
      injectToast();
    } else {
      document.addEventListener('DOMContentLoaded', injectToast);
    }
  }

  function initCartDiscountSync(code) {
    // Inietta stili CSS del Badge nel document header
    if (!document.getElementById('deceit-discount-badge-styles')) {
      const style = document.createElement('style');
      style.id = 'deceit-discount-badge-styles';
      style.textContent = `
        .deceit-discount-badge {
          background-color: #FCF40F;
          color: #0A0A0A;
          border: 2px solid #0A0A0A;
          padding: 0.75rem 1rem;
          font-family: 'ABCFavorit', Helvetica, Arial, sans-serif;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 0.875rem;
        }
        #Deceit-Discount-Remove-Btn {
          background: none;
          border: none;
          color: #0A0A0A;
          font-weight: 700;
          cursor: pointer;
          padding: 0;
          text-decoration: underline;
          font-family: inherit;
          font-size: 0.875rem;
          text-transform: uppercase;
          transition: color 0.15s ease;
        }
        #Deceit-Discount-Remove-Btn:hover {
          color: #0000FF !important;
        }
      `;
      document.head.appendChild(style);
    }

    // Sincronizza al caricamento iniziale se ci sono prodotti
    syncDiscountWithCart(code);

    // Ascolta gli eventi di aggiornamento carrello del tema (Dawn usa pubsub.js)
    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
        // Evitiamo loop infiniti se la sorgente dell'evento è lo script stesso
        if (event && event.source === 'deceit-discount') return;
        
        // Verifica se lo sconto è ancora nel cookie
        const currentCode = getCookie('discount_code');
        if (currentCode) {
          syncDiscountWithCart(currentCode);
        } else {
          hideDiscountBadge();
        }
      });
    }

    // Aggiungi MutationObserver per assicurarsi che il badge riappaia quando il drawer viene ri-renderizzato
    const drawer = document.getElementById('CartDrawer');
    if (drawer) {
      const observer = new MutationObserver((mutations) => {
        const wrapper = document.getElementById('Deceit-Discount-Wrapper');
        const currentCode = getCookie('discount_code');
        if (currentCode && (!wrapper || wrapper.style.display === 'none')) {
          updateBadgeUI(currentCode);
        }
      });
      observer.observe(drawer, { childList: true, subtree: true });
    }
  }

  // Funzione per applicare lo sconto via AJAX e aggiornare l'interfaccia
  function syncDiscountWithCart(code) {
    fetch((window.routes ? window.routes.cart_url : '/cart') + '.js')
      .then(res => res.json())
      .then(cart => {
        if (cart.item_count > 0) {
          // Verifica se lo sconto specifico è già applicato nativamente
          const codeApplied = cart.discount_applications && cart.discount_applications.some(
            app => app.title && app.title.toUpperCase() === code.toUpperCase()
          );
          
          if (!codeApplied) {
            // Applica lo sconto tramite /cart/update.js
            fetch((window.routes ? window.routes.cart_update_url : '/cart/update') + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ discount: code })
            })
            .then(res => res.json())
            .then(updatedCart => {
              updateBadgeUI(code);
              // Forza il re-rendering delle sezioni del carrello del tema Dawn
              if (typeof publish === 'function') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'deceit-discount', cartData: updatedCart });
              }
            });
          } else {
            updateBadgeUI(code);
          }
        } else {
          // Carrello vuoto: mostra comunque il badge come promemoria, ma senza fare chiamate AJAX
          updateBadgeUI(code);
        }
      })
      .catch(err => console.error('Errore sincronizzazione sconto carrello:', err));
  }

  function updateBadgeUI(code) {
    const wrapper = document.getElementById('Deceit-Discount-Wrapper');
    const valSpan = document.getElementById('Deceit-Discount-Code-Val');
    const removeBtn = document.getElementById('Deceit-Discount-Remove-Btn');

    if (wrapper && valSpan) {
      valSpan.textContent = code;
      wrapper.style.display = 'block';

      if (removeBtn) {
        // Rimuove eventuali vecchi listener prima di aggiungerne uno nuovo
        removeBtn.replaceWith(removeBtn.cloneNode(true));
        const newRemoveBtn = document.getElementById('Deceit-Discount-Remove-Btn');
        if (newRemoveBtn) {
          newRemoveBtn.addEventListener('click', function() {
            removeDiscount();
          });
        }
      }
    }
  }

  function hideDiscountBadge() {
    const wrapper = document.getElementById('Deceit-Discount-Wrapper');
    if (wrapper) {
      wrapper.style.display = 'none';
    }
  }

  function removeDiscount() {
    // Rimuove il cookie
    eraseCookie('discount_code');
    
    // Rimuove lo sconto dal carrello Shopify
    fetch((window.routes ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
    .then(res => res.json())
    .then(updatedCart => {
      hideDiscountBadge();
      // Nasconde anche il Toast se presente
      const toast = document.querySelector('.deceit-discount-toast');
      if (toast) toast.remove();

      // Forza il re-rendering del carrello per mostrare i prezzi pieni
      if (typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'deceit-discount', cartData: updatedCart });
      } else {
        window.location.reload();
      }
    })
    .catch(err => console.error('Errore rimozione sconto carrello:', err));
  }
})();
